<template>
  <div id="index" v-if="isAdmin">
    <el-container>
      <el-main class="loginclass">
        <img src="~assets/img/loginLogo.png" class="loginIcon"  alt="Failed to load image" />
        <el-row :gutter="24">
          <el-col :xs="0" :sm="10" :md="10" :lg="11" style="text-align: right">
            <img src="~assets/img/loginPic.png" class="login-pic" alt="Failed to load image" />
          </el-col>
          <el-col :xs="0" :sm="4" :md="4" :lg="2">
            <div class="logincenter"></div>
          </el-col>
          <el-col :xs="24" :sm="10" :md="10" :lg="11">
            <div v-if="show == '1'" class="login-box">
              <h3 class="login-title">
                <img src="~assets/img/loginTitle.png" alt="Failed to load image" />
              </h3>
              <div class="o365_login_show1">
                <a class="fl" style="font-size: 13pt" @click="o365Login"
                  >O365 Login</a
                >
                <div style="display:flex;width: 100%;">
                  <div @click="show = '2'" style="font-size: 12px;width: 50%;margin-left: -20px;">
                    Local Login
                  </div>
                  <div style="font-size: 12px;width: 50%; margin-top: -20px;display:none">
                    <el-dropdown
                    trigger="click"
                    style="margin-right: -90px;"
                    @command="handleSetLanguage"
                  >
                  <div> <span>中/En<i class="el-icon-arrow-right el-icon--right"></i></span></div>


                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item  command="zh-Hans">
                        简体中文
                      </el-dropdown-item>
                      <el-dropdown-item  command="en">
                        English
                      </el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                  </div>
                </div>
              </div>
            </div>
            <div v-else-if="show == '2'" class="login-box">
              <h3 class="login-title">
                <img src="~assets/img/loginTitle.png" alt="Failed to load image" />
              </h3>
              <el-form
                ref="form"
                :model="form"
                label-width="0px"
                class="login-input"
              >
                <el-form-item :label="changeT('Login:UserName')" prop="userNameOrEmailAddress">
                  <el-input
                    type="text"
                    placeholder=" "
                    v-model="form.userNameOrEmailAddress"
                  />
                </el-form-item>
                <el-form-item :label="changeT('Login:Password')" prop="password">
                  <el-input
                    @keyup.enter.native="login"
                    type="password"
                    placeholder=" "
                    v-model="form.password"
                    show-password
                  />
                </el-form-item>
                <el-button type="primary" class="lopginbtn" @click="login"
                  >{{ changeT('Login:Login') }}
                </el-button>
              </el-form>
              <div style="margin-top: 10px">
                <a
                  class="fl"
                  style="color: #fff; font-weight: bold; cursor: pointer"
                  @click="o365Login"
                  >O365登录</a
                >
                <div class="clear"></div>
                <div style="font-size: 12px;width: 50%; margin-top: -20px; color: #fff; font-weight: bold; margin-right:-90px;float: right; display:none">
                    <el-dropdown
                    trigger="click"
                    style="margin-right: -90px;"
                    @command="handleSetLanguage"
                  >
                  <div style="color: #fff;" > <span>中/En<i class="el-icon-arrow-right el-icon--right"></i></span></div>


                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item  command="zh-Hans">
                        简体中文
                      </el-dropdown-item>
                      <el-dropdown-item  command="en">
                        English
                      </el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                  </div>
              </div>

            </div>
            <div v-else-if="show == '3'" class="login-box">
              <h3 class="login-title">
                <img src="~assets/img/loginTitle.png" alt="Failed to load image" />
              </h3>
              <div style="color: #fff; font-weight: bold; margin-top: 40px">
                <div style="color: rgb(255 254 254)">
                  Trying to login in by O365, please wait a moment
                  {{ load }}
                </div>
                <div style="text-align: right">
                  <a
                    @click="o365LoginAgain"
                    class="f1"
                    style="cursor: pointer; font-size: 12px"
                    >Sign in again</a
                  >
                </div>
              </div>
            </div>


          </el-col>
        </el-row>
          <div class="loginRecordBox">
            <el-link  target="_blank"
              >{{ $t('NokiaCopyright') }}</el-link
            >
            <el-link  target="_blank"
              >{{ $t('Version') + version }}</el-link
            >
        </div>
      </el-main>
    </el-container>
  </div>
</template>

<script type="text/javascript">
import { authenticate, GetUserMenu ,getAppVersion,ChangeLanguage} from "../../api/api";
import { setCookie, getCookie } from "../../../utils/package-cookies";
import { setItemToLocalstorage } from "../../../utils/package-localstorage";
import { getO365Url, doO365Login } from "../../api/o365api";

import { setLoginLogic } from "../../utils/util";

export default {
  name: "Index",
  data() {
    return {
      showDropdown: false,
      show: "0",
      isAdmin: true,
      load: ".",
      // 对话框显示和隐藏
      dialogVisible: false,
      form: {
        userNameOrEmailAddress: "",
        password: "",
        languageName: "",
      },
      menuDat: [],
      ip: "",
      loadChart: "",
      version:''
    };
  },
  beforeCreate(){
    //如果是https，跳转到http
    if(process.env.VUE_APP_Https=='on'){
      if (window.location.href.split(":")[0] == "https") {
        window.location.href = "http:" + window.location.href.substring(6);
        return;
      }
    }
  },
  created(){
        this.InitCodeDeal()

    },
  mounted() {

    this.getVersion()
    var that = this;
    var i = 0;
    this.loadChart = setInterval(function () {
      if (i == 2) {
        that.load = ".";
        i = 0;
      } else {
        i++;
        that.load += " .";
      }
    }, 1000);
    const { $store } = this
    // $store.dispatch('applicationConfiguration',"zh-Hans").then((res) => {
    //   })
  },

  methods: {

    handleSetLanguage(lang) {
      const { $store } = this
      $store.dispatch('setLanguage', lang)
      $store.dispatch('applicationConfiguration',lang).then((res) => {
        if(res.success){
            this.$message({
            message: this.$t('LangChange'),
            type: 'success'
          })
        }
      })
    },

    query(name) {
      if (this.$route.query.code) return this.$route.query.code;

      var reg = new RegExp("(^|&)" + unescape(name) + "=([^&]*)(&|$)", "i");
      var r = window.location.search.substr(1).match(reg);
      if (r != null) return decodeURIComponent(r[2]);
      return null;
    },
    InitCodeDeal() {
      var that = this;
      //判断如果既不是admin，又没有code，就执行O365登录
      // if (this.query("admin") != "1230" && !this.query("code")) {
      //   o365Login();return;
      // }

      // //如果是https，跳转到http
      // if (window.location.href.split(":")[0] == "https") {
      //   window.location.href = "http:" + window.location.href.substring(6);
      //   return;
      // }
      var myQueryStr = this.query("code");
      if (!myQueryStr) {
        that.show="1"
        return;
      }
      debugger
      var stateStr =this.query("state");

      that.show = "3";
      //如果链接包含code参数，就执行O365登录，并且隐藏平台登录
      doO365Login({
        authProvider: "O365",
        providerKey: "string",
        providerAccessCode: myQueryStr,
        languageName : stateStr,
      })
        .then((res) => {
          setLoginLogic(that, res);
        })
        .catch((err) => {

          // if (!that || !err) {
          //   that.$message.error("Login Failed");
          //   return;
          // }
          console.log(err);
          //that.$message.error(err.error.message);
        });
    },
    async login() {
      this.submitForm("form");
    },
    o365Login() {
      //获取跳转url
      var that =this
      let data = that.$store.getters.language
      getO365Url(data).then((result) => {
        window.location.href = result.result;
        that.show = "3";
      });
      //跳转到指定地址

    },
    async o365LoginAgain() {
      this.show = "1";
    },
    async submitForm(formName) {
      var that = this;
      this.form.languageName = that.$store.getters.language
      await authenticate(this.form)
        .then((res) => {
            setLoginLogic(that, res);
          }
        );
    },
    getVersion(){
      //this.version = process.env.VUE_APP_VersionNo
        getAppVersion().then(res => {
            if (res.success) {
                this.version = res.result;
            }
        })
    },
    changeT(str) {
      if(str=="Login:Login") return "登录";
      if(str=="Login:UserName") return "用户名";
      if(str=='Login:Password') return "密码";
      return $t(str);
    },
  },
};
</script>
<style scoped>
.o365_login_show1 {
  display: flex;
  width: 100%;
  flex-direction: column;
  text-align: center;
  align-items: center;
}

.o365_login_show1 a {
  color: #fff;
  font-weight: bold;
  cursor: pointer;
  padding: 8px 20px;
  width: 75%;
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  border-radius: 5px;
  background-color: #409eff;
  border-color: #409eff;
}

.o365_login_show1 div {
  margin-top: 20px;
  color: #fff;
  font-weight: bold;
  cursor: pointer;
}

.loginclass {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-image: url("~assets/img/loginBG.jpg");
  background-position: bottom;
  background-repeat: no-repeat;
  background-size: cover;
}
</style>
